import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StaticContentComponent } from './static-content.component';
import { CommonLayoutModule, TranslationComponentsModule, CommonUIBasicModule, CommonUIElementsModule } from '@sdbn/common';


@NgModule({
  declarations: [
    StaticContentComponent
  ],
  exports: [
    StaticContentComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    CommonUIElementsModule,
    TranslationComponentsModule,
    CommonUIBasicModule
]
})
export class StaticContentComponentModule { }
